import type { QuotaCriteria } from '../models/survey-quota.model';

// A have-children row's one criterion always carries its age range's unit — the drawer sets it
// unconditionally the moment the row exists, even before an age/gender is actually chosen (see
// the child-age-gender drawer's blank-row builders) — while a no-children row's criterion never
// carries a range at all, on either the drawer-constructed or the inbound-decoded path (see
// toChildAgeGenderCriterion/fromChildAgeGenderCriterion). This is the one signal that survives
// every path a Children (218/232) quota criterion is built or round-tripped through, so it's the
// have-children/no-children discriminant — qualification_code and qualification_name can't be,
// now that both rows correctly share the real 218/"Children" values.
export function isHaveChildrenCriterion(
  criterion: Pick<QuotaCriteria, 'rangeUnit'>,
): boolean {
  return criterion.rangeUnit === 'month' || criterion.rangeUnit === 'year';
}
